var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimelineMessageicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M15.9502 8.7835C15.9527 9.76302 15.7239 10.7293 15.2822 11.6036C14.7586 12.6513 13.9536 13.5326 12.9575 14.1486C11.9613 14.7647 10.8133 15.0912 9.64201 15.0916C8.66249 15.0942 7.69622 14.8653 6.8219 14.4237L2.59174 15.8338L4.00179 11.6036C3.56017 10.7293 3.33132 9.76302 3.33387 8.7835C3.33432 7.61224 3.66086 6.46422 4.27691 5.46806C4.89297 4.47189 5.7742 3.66691 6.8219 3.14328C7.69622 2.70166 8.66249 2.47281 9.64201 2.47536H10.0131C11.5599 2.5607 13.021 3.21361 14.1164 4.30907C15.2119 5.40453 15.8648 6.86557 15.9502 8.41244V8.7835Z",
    stroke: "#6C757D",
    strokeWidth: 1.48724,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineMessageicon);
export default __webpack_public_path__ + "static/media/timeline-messageicon.665601c4c1b0b1c088d8f90d69be72c1.svg";
export { ForwardRef as ReactComponent };